module.exports = __webpack_public_path__ + "static/media/Calendario.99bfe226.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Calendario.svg
// module id = 2063
// module chunks = 0